import { Card, CardContent, CardFooter } from "./ui/card"
import { Button } from "../components/ui/button"
import { Calendar } from "lucide-react"
import { Link } from "react-router-dom"

export function DoctorCard({ name, specialty, experience, image, href }) {
  return (
    <Card className="overflow-hidden transition-all hover:shadow-md hover:translate-y-[-5px] duration-300">
      <div className="relative w-full h-68">
        <img
          src={image || "/placeholder.svg"}
          alt={name}
          className="object-cover w-full h-full"
        />
        
      </div>
      <CardContent className="p-4">
        <h3 className="text-lg font-bold">{name}</h3>
        <p className="text-primary">{specialty}</p>
        <p className="text-sm text-muted-foreground">{experience}</p>
      </CardContent>
      <CardFooter className="p-4 pt-0">
        <Button
          variant="outline"
          className="w-full gap-2 border-primary text-primary hover:bg-primary hover:text-white"
          asChild
        >
          <Link to="/book-appointment">
            <Calendar className="w-4 h-4" />
            Book Appointment
          </Link>
        </Button>
      </CardFooter>
    </Card>
  )
}